/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetIsBrandDeletable200ResponseReasons
 */
export interface GetIsBrandDeletable200ResponseReasons {
    /**
     * 
     * @type {boolean}
     * @memberof GetIsBrandDeletable200ResponseReasons
     */
    integrations: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetIsBrandDeletable200ResponseReasons
     */
    shop: boolean;
}

/**
 * Check if a given object implements the GetIsBrandDeletable200ResponseReasons interface.
 */
export function instanceOfGetIsBrandDeletable200ResponseReasons(value: object): value is GetIsBrandDeletable200ResponseReasons {
    if (!('integrations' in value) || value['integrations'] === undefined) return false;
    if (!('shop' in value) || value['shop'] === undefined) return false;
    return true;
}

export function GetIsBrandDeletable200ResponseReasonsFromJSON(json: any): GetIsBrandDeletable200ResponseReasons {
    return GetIsBrandDeletable200ResponseReasonsFromJSONTyped(json, false);
}

export function GetIsBrandDeletable200ResponseReasonsFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetIsBrandDeletable200ResponseReasons {
    if (json == null) {
        return json;
    }
    return {
        
        'integrations': json['integrations'],
        'shop': json['shop'],
    };
}

export function GetIsBrandDeletable200ResponseReasonsToJSON(json: any): GetIsBrandDeletable200ResponseReasons {
    return GetIsBrandDeletable200ResponseReasonsToJSONTyped(json, false);
}

export function GetIsBrandDeletable200ResponseReasonsToJSONTyped(value?: GetIsBrandDeletable200ResponseReasons | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'integrations': value['integrations'],
        'shop': value['shop'],
    };
}

